import { useNavigate } from "react-router-dom"
import { AuthService } from "../services/auth.service"
import { useEffect, useState } from "react"
import { DataService } from "../services/data.service"
import { MainLayout } from "./MainLayout"
import { ListModel } from "../models/list.model"
import { UserModel } from "../models/user.model"
import { Beneficiary } from "./Beneficiary"
import { useLogout } from "../hooks/logout.hook"
import { Card } from "./ui/card"
import { LayoutDashboard, RefreshCcw } from "lucide-react"
import { PageTitle } from "./PageTitle"
import { debugModeActive, isNotInMobileApp} from "../lib/utils"

export function Dashboard() {
    const navigate = useNavigate()
    const logout = useLogout()
    const [users, setUsers] = useState<ListModel<UserModel>>()
    const [timeSinceLastUpdate, setTimeSinceLastUpdate] = useState(0)

    useEffect(() => {
        if (!AuthService.hasAuth()) {
            navigate('/login', { replace: true })
            return
        }

        loadData()
        const interval = setInterval(() => {
            loadData(true)
        }, 15 * 60 * 1000)

        const timer = setInterval(() => {
            setTimeSinceLastUpdate(prev => prev + 1)
        }, 1000)

        return () => {
            clearInterval(interval)
            clearInterval(timer)
        }
    }, [])

    function loadData(silent = false) {
        DataService.getUsers(silent)
            .then(data => {
                setTimeSinceLastUpdate(0)
                setUsers(data)
            })
            .catch(e => logout())
    }

    function openDetails(id: number) {
        navigate('/dashboard/' + id, { replace: true })
    }

    return (
        <MainLayout>
            {isNotInMobileApp() &&
                <PageTitle>
                    <LayoutDashboard className="text-3xl text-gray-800" size={32} />
                    <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>
                </PageTitle>
            }

            <div className="space-y-2">
                {users &&
                    <Card className="p-4 shadow-md rounded-lg border">
                        <div className="text-sm flex justify-center items-center gap-2">
                            <p>
                                {Math.floor(timeSinceLastUpdate / 60)}m {timeSinceLastUpdate % 60}s since last report
                            </p>
                            <RefreshCcw
                                className="cursor-pointer"
                                onClick={() => loadData()}
                            />
                        </div>
                        {debugModeActive() &&
                            <div className="text-center text-sm text-gray-400">Build Version: {process.env.REACT_APP_VERSION}</div>
                        }
                    </Card>
                }

                {users && users.result_list.map((user, index) => (
                    <div key={index} onClick={e => openDetails(user.deployment_id)}>
                        <Beneficiary user={user} />
                    </div>
                ))}
            </div>
        </MainLayout>
    )
}